import routerOptions0 from "/fire-bang-frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}